import { isAdminEditorial, isPublisher } from 'app/models/user';

export const ACCESS_LEVELS = ['editor', 'reviewer'];

export const EDITORIAL_ACCESS_STATUS = { error: 'error', idle: 'idle', loading: 'loading', ready: 'ready' };

// "none" es la ausencia de perfil, no un nivel del contrato.
export const ACCESS_PROFILE_NONE = 'none';

export const ACCESS_PROFILES = [ACCESS_PROFILE_NONE, ...ACCESS_LEVELS];

export const Model = { enabled: false, access_level: null };

export const ModelMe = {
  feature_enabled: false,
  restricted: false,
  access_level: null,
  invited_programs: [],
  program_access_enforced: false,
  reviewer_write_enforced: false,
};

export function canAdministerEditorialAccess(user, flag) {
  return isAdminEditorial(user) && flag === true;
}

export function isEditorialAccessTarget(user) {
  return isPublisher(user);
}

// Un perfil incompleto se rechaza: asumirlo como "sin restricción" abriría el acceso que cierra.
export function isValidProfile(data) {
  if (typeof data?.enabled !== 'boolean') return false;
  if (data.access_level !== null && !ACCESS_LEVELS.includes(data.access_level)) return false;
  return !data.enabled || ACCESS_LEVELS.includes(data.access_level);
}

export function isValidAccessMe(data) {
  if (typeof data?.feature_enabled !== 'boolean' || typeof data.restricted !== 'boolean' || !Array.isArray(data.invited_programs)) return false;
  if (data.program_access_enforced !== undefined && typeof data.program_access_enforced !== 'boolean') return false;
  if (data.reviewer_write_enforced !== undefined && typeof data.reviewer_write_enforced !== 'boolean') return false;
  if (data.access_level !== null && !ACCESS_LEVELS.includes(data.access_level)) return false;
  return !data.restricted || (data.feature_enabled && ACCESS_LEVELS.includes(data.access_level));
}

export function sanitizeData(data) {
  return { ...Model, enabled: data.enabled, access_level: data.access_level };
}

export function sanitizeEditorialAccessMe(data) {
  return {
    ...ModelMe,
    feature_enabled: data.feature_enabled,
    restricted: data.restricted,
    access_level: data.access_level,
    invited_programs: data.invited_programs,
    program_access_enforced: data.program_access_enforced === true,
    reviewer_write_enforced: data.reviewer_write_enforced === true,
  };
}

export function toAccessProfile(profile) {
  if (!profile?.enabled) return ACCESS_PROFILE_NONE;

  return ACCESS_LEVELS.includes(profile.access_level) ? profile.access_level : null;
}

export function fromAccessProfile(selected, profile) {
  return { enabled: selected !== ACCESS_PROFILE_NONE, access_level: selected === ACCESS_PROFILE_NONE ? profile?.access_level ?? null : selected };
}

export function serializeProfile(profile) {
  return { enabled: profile.enabled, access_level: profile.access_level };
}

// El enforcement lo activa el backend: sin `program_access_enforced` el front conserva el acceso
// heredado, para que un API desplegado antes que este front no deje al editor sin catálogo.
export function hasRestrictedProgramAccess(state, user) {
  return isPublisher(user) && state?.status === EDITORIAL_ACCESS_STATUS.ready && state.data?.restricted === true && state.data?.program_access_enforced === true;
}

// Solo el programa abierto define el ámbito: usar el pathname completo revalidaría el permiso
// —y desmontaría la aplicación— en cada navegación.
export function getEditorialNavigationScope(pathname) {
  const program = /^\/program\/(?:mint-stand-alone\/)?([^/]+)/.exec(pathname);
  return program ? `/program/${program[1]}` : '';
}
